export default __webpack_public_path__ + "static/media/titanic.420c2c26.mp3";